import React from 'react';
import { type LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center py-16 gap-3 text-center">
    <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center text-slate-400">
      <Icon size={22} strokeWidth={1.5} />
    </div>
    <p className="text-sm font-medium text-slate-600">{title}</p>
    {description && <p className="text-xs text-slate-400 max-w-xs">{description}</p>}
    {action && (
      <Button size="sm" variant="outline" onClick={action.onClick} className="mt-1">
        {action.label}
      </Button>
    )}
  </div>
);

export default EmptyState;
